import React, { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Heart, Sparkles } from 'lucide-react';

export default function FamilyValuesSong() {
  const [values, setValues] = useState(['', '', '']);
  const [showSong, setShowSong] = useState(false);

  const updateValue = (index, value) => {
    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);
  };

  const completeSong = () => {
    if (values[0] && values[1] && values[2]) {
      setShowSong(true);
    }
  };

  return (
    <div className="relative my-12">
      {!showSong ? (
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-4 border-amber-600 rounded-lg p-8 transform rotate-1 shadow-2xl max-w-3xl mx-auto">
          <div className="transform -rotate-1">
            <div className="flex items-center justify-center gap-3 mb-6">
              <Heart className="h-8 w-8 text-rose-600" />
              <h3 className="text-2xl font-bold text-amber-900" style={{ fontFamily: "'Comic Sans MS', 'Brush Script MT', cursive" }}>
                Your Family's Song
              </h3>
              <Heart className="h-8 w-8 text-rose-600" />
            </div>
            
            <p className="text-amber-800 leading-relaxed mb-6 text-center italic">
              It may be beneficial to casually think about what are the most cherished values that you and your family strive to live by. Try completing these song lyrics…
            </p>

            <div className="space-y-4 bg-white/60 p-6 rounded border-2 border-amber-400">
              <div>
                <label className="text-amber-900 font-semibold mb-2 block" style={{ fontFamily: "'Comic Sans MS', cursive" }}>
                  1st cherished value:
                </label>
                <Input 
                  value={values[0]}
                  onChange={(e) => updateValue(0, e.target.value)}
                  placeholder="e.g., Compassion"
                  className="border-2 border-amber-600 text-amber-900 placeholder:text-amber-400 bg-amber-50/50 text-lg"
                  style={{ fontFamily: "'Comic Sans MS', cursive" }}
                />
              </div>
              
              <div>
                <label className="text-amber-900 font-semibold mb-2 block" style={{ fontFamily: "'Comic Sans MS', cursive" }}>
                  2nd cherished value:
                </label>
                <Input 
                  value={values[1]}
                  onChange={(e) => updateValue(1, e.target.value)}
                  placeholder="e.g., Connection"
                  className="border-2 border-amber-600 text-amber-900 placeholder:text-amber-400 bg-amber-50/50 text-lg"
                  style={{ fontFamily: "'Comic Sans MS', cursive" }}
                />
              </div>
              
              <div>
                <label className="text-amber-900 font-semibold mb-2 block" style={{ fontFamily: "'Comic Sans MS', cursive" }}>
                  3rd cherished value:
                </label>
                <Input 
                  value={values[2]}
                  onChange={(e) => updateValue(2, e.target.value)}
                  placeholder="e.g., Growth"
                  className="border-2 border-amber-600 text-amber-900 placeholder:text-amber-400 bg-amber-50/50 text-lg"
                  style={{ fontFamily: "'Comic Sans MS', cursive" }}
                />
              </div>
            </div>
            
            {/* Complete Button */}
            <div className="mt-6 flex justify-center">
              <Button 
                onClick={completeSong}
                disabled={!values[0] || !values[1] || !values[2]}
                className="bg-amber-600 hover:bg-amber-500 text-white px-8 py-3 text-lg transform hover:scale-105 transition-all"
              >
                <Sparkles className="h-5 w-5 mr-2" />
                Complete the Song!
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-gradient-to-br from-rose-100 to-pink-100 border-4 border-rose-600 rounded-lg p-10 shadow-2xl max-w-4xl mx-auto transform hover:scale-[1.02] transition-all duration-500">
          <div className="text-center space-y-6">
            <div className="flex justify-center gap-4 mb-6">
              <Heart className="h-12 w-12 text-rose-600 animate-pulse" />
              <Heart className="h-12 w-12 text-rose-600 animate-pulse" style={{ animationDelay: '0.5s' }} />
              <Heart className="h-12 w-12 text-rose-600 animate-pulse" style={{ animationDelay: '1s' }} />
            </div>
            
            <div 
              className="text-3xl md:text-4xl leading-relaxed text-rose-900"
              style={{ fontFamily: "'Brush Script MT', 'Comic Sans MS', cursive" }}
            >
              <p className="mb-4">Off balance was I dreaming,</p>
              <p className="mb-4">but my thoughts were clear,</p>
              <p className="mb-4">right then I remembered,</p>
              <p className="text-4xl md:text-5xl font-bold text-rose-700">three things we hold most dear...</p>
            </div>

            <div className="space-y-3 mt-8 bg-white/70 p-8 rounded-lg border-2 border-rose-400">
              <p className="text-3xl font-bold text-rose-800" style={{ fontFamily: "'Brush Script MT', cursive" }}>
                ✨ {values[0]} ✨
              </p>
              <p className="text-3xl font-bold text-rose-800" style={{ fontFamily: "'Brush Script MT', cursive" }}>
                ✨ {values[1]} ✨
              </p>
              <p className="text-3xl font-bold text-rose-800" style={{ fontFamily: "'Brush Script MT', cursive" }}>
                ✨ {values[2]} ✨
              </p>
            </div>

            <button
              onClick={() => setShowSong(false)}
              className="mt-6 text-rose-600 hover:text-rose-800 underline text-sm"
              style={{ fontFamily: "'Comic Sans MS', cursive" }}
            >
              ← Edit your values
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
